import { useSuspenseQuery } from '@apollo/client';

import type { TopCompaniesQueryVariables } from '../../graphql/queries/top-companies.gql-types';
import { TopCompaniesDocument } from '../../graphql/queries/top-companies.gql-types';

export const useTopCompanies = ({
  limit,
  offset,
}: TopCompaniesQueryVariables) => {
  const variables = {
    limit,
    offset,
  };

  const response = useSuspenseQuery(TopCompaniesDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return response;
};
